// ** React Imports
import { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

// ** Store & Actions
import { useDispatch } from 'react-redux'
import { handleLogout } from '@store/authentication'

// ** Utils
import { isUserLoggedIn } from '@utils'

// ** Third Party Components
import { Moon, Power, Sun, User } from 'react-feather'
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from 'reactstrap'

// ** Custom Components
import MyProfileModal from '@src/@core/layouts/components/navbar/MyProfileModal'

// ** Nav model
import { formatRoles, initialsOf } from './navModel'

// Logged-in user + theme toggle, docked at the bottom of the side panel
const UserCard = ({ skin, setSkin }) => {
  const dispatch = useDispatch()
  const [userData, setUserData] = useState(null)
  const [showMyProfile, setShowMyProfile] = useState(false)

  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')))
    }
  }, [])

  const name = userData?.name || 'User'
  const role = formatRoles(userData?.role)
  const isDark = skin === 'dark'

  return (
    <Fragment>
      <div className="nav-panel__user">
        <UncontrolledDropdown direction="up" className="ntts-user-menu">
          <DropdownToggle
            tag="button"
            type="button"
            className="ntts-user-card__toggle"
            aria-label="Account menu"
          >
            <span className="user-chip__avatar" aria-hidden="true">
              {initialsOf(name)}
            </span>
            <span className="user-chip__text">
              <span className="user-chip__name" title={name}>
                {name}
              </span>
              {role && <span className="user-chip__role">{role}</span>}
            </span>
          </DropdownToggle>
          <DropdownMenu container="body" className="ntts-user-menu__list">
            <DropdownItem onClick={() => setShowMyProfile(true)}>
              <User />
              <span>My Profile</span>
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem
              tag={Link}
              to="/login"
              onClick={() => dispatch(handleLogout())}
            >
              <Power />
              <span>Logout</span>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>

        <button
          type="button"
          className="icon-btn icon-btn--ghost ntts-user-card__theme"
          aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
          title={isDark ? 'Light theme' : 'Dark theme'}
          onClick={() => setSkin(isDark ? 'light' : 'dark')}
        >
          {isDark ? <Moon /> : <Sun />}
        </button>
      </div>

      {showMyProfile ? (
        <MyProfileModal
          isOpen={showMyProfile}
          close={() => setShowMyProfile(false)}
          setShow={setShowMyProfile}
        />
      ) : null}
    </Fragment>
  )
}

export default UserCard
